import { defineStore, IStoreState } from "@/utils/store"

export const retainPop = defineStore({
    state: {
        isShowPop: false,
        toUrl: ''
    },
    mutations: {
        update(state, data) {
            state.isShowPop = data.isShowPop
            state.toUrl = data.toUrl
        },
    },
})

export default retainPop
export type ICommonStoreState = IStoreState<typeof retainPop.state>